import React from 'react';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { green, blue } from '@material-ui/core/colors';
import { fade } from '@material-ui/core/styles/colorManipulator';

import NumberRules from './charts/NumberRules';
import CubejsCard from './CubejsCard';


const useStyles = makeStyles({
    productivas: {
        backgroundColor: fade(green[800], 0.4),
    },
    enDesarrollo: {
        backgroundColor: fade(blue[800], 0.4),
    },
});

const ReglasPorEstadoCard = (props) => {
    const classes = useStyles();
    return (
        <CubejsCard title="Reglas" {...props}>
            <Grid container spacing={3}>
                    <Grid item sm={6} >
                        <Typography variant="subtitle1" color="textSecondary">
                                Productivas
                        </Typography>
                        <div className={classes.productivas}>
                            <NumberRules tiporegla="Productiva"/>
                        </div>
                        
                    </Grid>
                    <Grid item sm={6}>
                            <Typography variant="subtitle1" color="textSecondary">
                                    En desarrollo
                            </Typography>
                            <div className={classes.enDesarrollo}>
                                <NumberRules tiporegla="Desarrollo"/>
                            </div>
                    </Grid>
                </Grid>
        </CubejsCard>
    );
}

export default ReglasPorEstadoCard;
